module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"file-upload btn-file-container\"> <div class=\"btn btn-red filter-panel-btn\"> ")
    ;  if (locals.uploading) { 
    ; __append(" <div class=\"loader-sm\"> <div class=\"sk-three-bounce white\"> <div class=\"sk-child sk-bounce1\"></div> <div class=\"sk-child sk-bounce2\"></div> <div class=\"sk-child sk-bounce3\"></div> </div> </div> ")
    ;  } else { 
    ; __append(" <span>Upload Orders (CSV)</span> ")
    ;  } 
    ; __append(" <input type=\"file\" class=\"read-file btn-file\" accept=\"text/csv\"> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/fulfillment_orders/upload_orders.ejs
// module id = 838
// module chunks = 1